import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/login-register.css';
import { Modal, Button } from 'react-bootstrap';
import API_URL from "../config/api";

const AuthPage = () => {
    const navigate = useNavigate();

    const [isSignUpMode, setIsSignUpMode] = useState(false);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleEmailLink = () => {
        window.open('https://mail.google.com', '_blank');
    };

    /* =====================
       SIGN UP (FIXED)
    ====================== */
    const handleSignUp = async (e) => {
        e.preventDefault();

        if (!username || !email || !password) {
            toast.error("All fields are required.");
            return;
        }

        try {
            const response = await fetch(`${API_URL}/auth/register.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        username,
                        email,
                        password,
                    }),
                }
            );

            const data = await response.json();

            if (data.success) {

                setSuccessMessage(data.message);
                setShowSuccessModal(true);

                setUsername("");
                setEmail("");
                setPassword("");

            } else {

                toast.error(data.message);

            }

        } catch (err) {
            console.error(err);
            toast.error("Server error.");
        }
    };

    /* =====================
       SIGN IN (FIXED)
    ====================== */
    const handleSignIn = async (e) => {
        e.preventDefault();

        if (!username || !password) {
            toast.error("Username and password are required.");
            return;
        }

        try {

            const response = await fetch(`${API_URL}/auth/login.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        username,
                        password,
                    }),
                }
            );

            const data = await response.json();

            if (data.success) {

                // Save logged in user
                localStorage.setItem("user", JSON.stringify(data.user));

                toast.success(data.message);

                setTimeout(() => {
                    navigate("/AddTree");
                }, 1000);

            } else {

                toast.error(data.message);

            }

        } catch (err) {

            console.error(err);

            toast.error("Server error.");

        }
    };

    /* =====================
       RETURN (YOUR UI)
    ====================== */
    return (
        <>
            <div className={`authpage ${isSignUpMode ? 'sign-up-mode' : ''}`} id="particles">
                <div className="forms-container" id="webcoderskull">
                    <div className="signin-signup">

                        {/* Sign-in form */}
                        <form onSubmit={handleSignIn} className="sign-in-form">
                            <h2 className="title">Sign in</h2>
                            <div className="input-field">
                                <i className="fas fa-user"></i>
                                <input
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div className="input-field">
                                <i className="fas fa-lock"></i>
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <input type="submit" value="Login" className="btn solid" />
                            <Link to="/forgotpass">Forget password</Link>
                        </form>

                        {/* Sign-up form */}
                        <form onSubmit={handleSignUp} className="sign-up-form">
                            <h2 className="title">Sign up</h2>
                            <div className="input-field">
                                <i className="fas fa-user"></i>
                                <input
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div className="input-field">
                                <i className="fas fa-envelope"></i>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="input-field">
                                <i className="fas fa-lock"></i>
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <input type="submit" className="btn" value="Sign up" />
                        </form>

                    </div>
                </div>

                <div className="panels-container">
                    <div className="panel left-panel">
                        <div className="content" id="logsigncontent">
                            <h3>New here ?</h3>
                            <p>Create your account to get started.</p>
                            <button
                                className="btn transparent"
                                onClick={() => setIsSignUpMode(true)}
                            >
                                Sign up
                            </button>
                        </div>
                    </div>

                    <div className="panel right-panel">
                        <div className="content" id="logsigncontent">
                            <h3>One of us ?</h3>
                            <p>Login to continue.</p>
                            <button
                                className="btn transparent"
                                onClick={() => setIsSignUpMode(false)}
                            >
                                Sign in
                            </button>
                        </div>

                        <ToastContainer position="top-center" />
                    </div>
                </div>

                {/* EMAIL VERIFICATION MODAL */}
                <Modal show={showVerificationModal} onHide={() => setShowVerificationModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Email Verification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Please check your email to verify your account.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleEmailLink}>
                            Verify
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => setShowVerificationModal(false)}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            {/* Registration Success Modal */}
            <Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Registration Successful</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <div style={{ fontSize: "60px", color: "#28a745" }}>
                        ✔
                    </div>

                    <h5 className="mt-3">
                        Account Created Successfully!
                    </h5>

                    <p>{successMessage}</p>

                    <small className="text-muted">
                        Please wait for the administrator to verify your account before you can log in.
                    </small>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={() => {
                            setShowSuccessModal(false);
                            setIsSignUpMode(false); // Return to Sign In
                        }}
                    >
                        Go to Login
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AuthPage;
